import React from 'react';

const DashboardDefault = () => {
    return (
        <div className='w-full h-screen flex items-center justify-center'>
            <h1 className='-mt-8 text-6xl font-bold'>Welcome to <span className='text-blue-400'>UniCar</span></h1>
        </div>
    );
};

export default DashboardDefault;